import { encrypt } from '../helpers/Helpers';

export default async function CheckCode({crewCode, code}) {
    // Encriptar el código antes de enviar
    const encryptedCode = encrypt(code, process.env.REACT_APP_KEY);

    const url = "https://gops.azulhandling.com/LoginPage/procesos_seguros/CheckCode.php";
    const res = await fetch(url, {
        method: 'POST',
        body: JSON.stringify({
            crewCode,
            code: encryptedCode
        }),
    })
    
    if(res.status == 200){
        return await res.text()
    }else{
        return "Error obteniendo los datos"
    }
}